import { atom } from "nanostores";

import { LocalStorageService } from "@vega-core/service/LocalStorage.service";

export const $txId = atom<string | null>(LocalStorageService.getTxId());

export const setTxId = (txId: string) => {
  LocalStorageService.setTxId(txId);
  $txId.set(txId);
};

export const clearTxId = () => {
  LocalStorageService.removeTxId();
  $txId.set(null);
};
